import { createContext, useContext } from 'react';

export const IntlContext = createContext();
export default function useFormatMessage() {
  const intl = useContext(IntlContext);
  return intl.formatMessage;
}
